/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DuplicateWidgetRequestBody,
  DuplicateWidgetRequestBody$Outbound,
  DuplicateWidgetRequestBody$outboundSchema,
} from "../components/duplicatewidgetrequestbody.js";

export type DuplicateWidgetSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DuplicateWidgetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  duplicateWidgetRequestBody: DuplicateWidgetRequestBody;
};

/** @internal */
export type DuplicateWidgetSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DuplicateWidgetSecurity$outboundSchema: z.ZodMiniType<
  DuplicateWidgetSecurity$Outbound,
  DuplicateWidgetSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function duplicateWidgetSecurityToJSON(
  duplicateWidgetSecurity: DuplicateWidgetSecurity,
): string {
  return JSON.stringify(
    DuplicateWidgetSecurity$outboundSchema.parse(duplicateWidgetSecurity),
  );
}

/** @internal */
export type DuplicateWidgetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DuplicateWidgetRequestBody: DuplicateWidgetRequestBody$Outbound;
};

/** @internal */
export const DuplicateWidgetRequest$outboundSchema: z.ZodMiniType<
  DuplicateWidgetRequest$Outbound,
  DuplicateWidgetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    duplicateWidgetRequestBody: DuplicateWidgetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      duplicateWidgetRequestBody: "DuplicateWidgetRequestBody",
    });
  }),
);

export function duplicateWidgetRequestToJSON(
  duplicateWidgetRequest: DuplicateWidgetRequest,
): string {
  return JSON.stringify(
    DuplicateWidgetRequest$outboundSchema.parse(duplicateWidgetRequest),
  );
}
